import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { Heading } from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../../../enums';

export const Header = styled(Heading)`
	color: ${palette.mlcWhite};
	font-stretch: normal;
	font-style: normal;
	font-variant: small-caps;
	letter-spacing: normal;
	margin-bottom: 0;
	margin-top: 0;
	outline: 0;
	padding: 60px 0 33px 0;

	@media (max-width: ${ScreenSize.medium}) {
		padding: 24px 0;
	}
`;

export const WhiteHeader = styled(Heading)`
	color: ${palette.mlcWhite};
	margin-top: 0;

	@media (max-width: ${ScreenSize.xSmall}) {
		line-height: 2.4;
	}
`;
